import React from 'react';
import './Chapters.scss';
import e from '../../Assets/E.svg';

function Chapter1() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          <span className="chapter__paragraph--dropcap">
            <img src={e} alt="dropcap" />
          </span>
          arly on the morning of February 24, 2022, Russia launched a full-scale invasion of
          Ukraine. David Hartshorn watched the crisis unfold from half a world away in Washington
          D.C. He watched as each day, Russian forces pushed deeper into Ukraine, sending countless
          Ukrainians fleeing for safety from the onslaught.
        </p>
        <p className="chapter__paragraph">
          Within weeks, the invasion had triggered the worst refugee crisis in Europe since the
          Second World War. Some 10 million Ukrainians, nearly a quarter of the country’s
          population, had left their homes. Over 3 million became refugees, massing at the borders
          of neighboring countries. 90% of them were women and children with a need to contact their
          loved ones back home and no way to get the information they needed to find work, shelter,
          or safety in their new surroundings. Hartshorn knew he needed to help, but he wasn’t sure
          how.
        </p>
        <p className="chapter__paragraph">
          As CEO of Geeks Without Frontiers, a global non-profit humanitarian organization,
          Hartshorn knew how to make a difference when people were in dire conditions. Under his
          leadership, Geeks Without Frontiers used technology to connect people when they needed it
          most, whether they were stranded in disaster areas or isolated on fishing vessels in the
          middle of our planet’s oceans.
        </p>
      </section>
    </>
  );
}

export default Chapter1;
